import React from 'react';

const Error = (props) => (
    <div className="error-container">
        <h3>{props.message}</h3>
    </div>
);

export default Error;